import React from 'react'
import { useTranslation } from 'react-i18next';
import TextInput from '../../../components/TextInput'
import styles from "./ComposeMail.module.css";
import InputBox from '../../../components/Modal/Email/InputBox';

const ComposeMail = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.Container}>
        <InputBox Text={t('screens.email.secure.toLabel')} customStyle={{backgroundColor : "white" , height: "3rem"}} />
        <InputBox Text={t('screens.email.secure.ccLabel')} customStyle={{backgroundColor: "white", height: "3rem" }}/>
        <InputBox Text={t('screens.email.secure.subjectLabel')} customStyle={{backgroundColor: "white" , height: "3rem"}}/>
        <InputBox type='textArea' placeholder={t('screens.email.secure.typeYourEmail')}/>
    </div>
  )
}

export default ComposeMail